import { useQuery } from "@tanstack/react-query";
import { TemplateServiceApi } from "api/services";
import { TemplateService } from "@adfenix/types";
const {
  imageTemplate: { authV2ImageTemplateDetail2: getImageTemplates }
} = TemplateServiceApi;

export const getImageTemplatesKey = "getImageTemplatesForOwner";

export const useGetImageTemplates = (
  ownerId?: string,
  select?: (
    data: TemplateService.ImageTemplateModel[]
  ) => TemplateService.ImageTemplateModel[]
) =>
  useQuery(
    [getImageTemplatesKey, ownerId],
    () => (ownerId ? getImageTemplates("hq", ownerId) : Promise.reject()),
    {
      select
    }
  );
